import { createContext, useContext } from 'react';

/**
 * Context para compartilhar o displayLocation com componentes filhos
 * Permite que o Outlet use a location atrasada durante animações
 */
export const DisplayLocationContext = createContext(null);

export const useDisplayLocation = () => {
  return useContext(DisplayLocationContext);
};
